<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 180px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 180px);">
        <div class="container-fluid mg-y-30">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style4 mg-b-10">
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Шинэ ажилтан</router-link></li>
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Тавтай морил</router-link></li>
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyQuiz' }" class="tx-11" style="color: #444">Тоглох уу?</router-link></li>
              <li class="breadcrumb-item active tx-14" aria-current="page">Соёлын кодекс</li>
            </ol>
          </nav>


          <div class="d-flex mg-t-20" v-if="activeQid>0">
            <div class="bg-white rounded-20 wd-50p d-flex align-items-center" style="min-height:50vh">
              <div class="text-center tx-bold tx-30 pd-40 wd-100p" v-html="questions.filter((x)=>x.id==activeQid)[0]['s1']"></div>
            </div>
            <div class="wd-50p pd-l-20">
              <div @click="submitQuestion(questions.filter((x)=>x.id==activeQid)[0], a)" v-for="(a, ai) in questions.filter((x)=>x.id==activeQid)[0]['a']" :class="`${calculateClass(a)}`"
                class="cursor-pointer">
                <div class="pd-r-30">{{ alphabetize(ai) }}.</div>
                <div v-html="a.s1"></div>
                <!-- <div class="ml-auto">{{ a.isFilled }} {{ a.b1 }}</div> -->
              </div>
              
              <div class="border-l-4 bd-primary pd-x-10 pd-y-5" v-if="questions.filter((x)=>x.id==activeQid)[0]['isFilled']">
                ! Tip {{ questions.filter((x)=>x.id==activeQid)[0]['s2'] }}
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

      <div class="bg-white pos-absolute ht-100 b-0 l-0 wd-100p d-flex align-items-center pd-x-30">
        <div v-if="activeQid>0" class="d-flex align-items-center wd-100p">
          
          <div class="d-flex align-items-center">
            <div v-if="totalSec!=null" class="px-3 py-2 mr-3 border-2 border-yellow-500 rounded-md">
              <vue-countdown
                    @end="finishForm(false)"
                    :time="totalSec * 1000"
                    v-slot="{ days, hours, minutes, seconds }"
                    >{{ (hours*60)+minutes }}'' :
                    {{ seconds }}'</vue-countdown
                  >
            </div>
            <div class="progress wd-100 mg-r-10 ht-15">
              <div class="progress-bar" role="progressbar" :style="`width: ${calcPercent()}%`"></div>
            </div>
            <div>Явц: {{ calcPercent() }}<sup>%</sup></div>
            <div class="pl-1">({{questions.findIndex(x=>x.id==activeQid)+1}}/{{ questions.length }})</div>
          </div>
          <div @click="nextQuestion()" v-if="questions.filter((x)=>x.id==activeQid)[0]['isFilled']" role="button" class="text-white mg-l-auto bg-primary rounded-10 pd-x-20 pd-y-15 tx-semibold">Үргэлжлүүлэх</div>
          <div v-else @click="openMustFillMsg()" role="button" class="mg-l-auto bg-light text-muted rounded-10 pd-x-20 pd-y-15 tx-semibold">Үргэлжлүүлэх</div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";
import { alphabetize } from "@/libs/tools";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, MessageBox } from "element-ui";

import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  components: {
    vueCustomScrollbar,
    VueCountdown,
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      questions: [],
      activeQid: null,
      resultId: null,
      totalSec: null
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    finishForm(){
      this.totalSec= null;
      MessageBox.confirm("Дахин бөглөх үү ?",
        "Цаг дууссан байна.",
        {
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          callback: action => {
            if (action == "cancel") {
              this.$router.push({name: 'buddyQuiz'});
              //console.log('step 1');
            } else if (action == "confirm") {
              this.reFill(this.resultId);
            }
          }
        }
      );
    },
    openMustFillMsg(){
      Notification.warning({
        title: "Мэдэгдэл",
        message: `Асуултад хариулснаар үргэлжлүүлэх боломжтой`,
        duration: 3000,
        position: "bottom-left",
      });
    },
    calcPercent(){
      const questions = this.questions;
      if (!questions || !questions.length) return '0.0';
      const filledCount = questions.filter(q => q.isFilled).length;
      const totalQuestions = questions.length;
      const percentage = (filledCount / totalQuestions) * 100;
      return isNaN(percentage) ? '0.0' : percentage.toFixed(1);
    },
    nextQuestion(){
      const currentIndex = this.questions.findIndex(x => x.id === this.activeQid);
      if (currentIndex !== this.questions.length - 1) {
        this.activeQid = this.questions[currentIndex + 1]['id'];
      } else {
        MessageBox.confirm("Дахин эхлүүлэх үү ?",
          "Тоглож дууслаа.",
          {
            confirmButtonText: "Тийм",
            cancelButtonText: "Үгүй",
            callback: action => {
              if (action == "cancel") {
                this.$router.push({name: 'buddyQuiz'});
              } else if (action == "confirm") {
                this.reFill(this.resultId);
                
              }
            }
          }
        );
        // this.$router.push({ name: 'buddyParticipant' });
      }
    },
    calculateClass(answer){
      let rv='bg-white rounded-20 d-flex align-items-center pd-20 mg-b-20 tx-14 tx-semibold';
      if(this.questions.filter((x)=>x.id==this.activeQid)[0]['isFilled']){
        if(answer.isFilled && answer.b1==100){
          rv='bg-success rounded-20 d-flex align-items-center pd-20 mg-b-20 tx-14 tx-semibold';
        }else if(answer.isFilled && answer.b1!=100){
          rv='bg-white bd bd-danger rounded-20 d-flex align-items-center pd-20 mg-b-20 tx-14 tx-semibold';
        } else if(!answer.isFilled && answer.b1==100){
          rv='bg-white bd bd-success rounded-20 d-flex align-items-center pd-20 mg-b-20 tx-14 tx-semibold';
        }
      }
      return rv;
    },
    alphabetize(v) {
      return alphabetize(v);
    },
    showVid(n){
      this.mdl.show= true;
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    submitQuestion(q, a, str, isForce){
      let _data = {
          formId: this.$route.params.formId,
          questionId: q.id,
          answerId: a.id,
          str: null,
          courseId: this.$route.params.id,
          lessonId: null,
        };
      request({
          api: { method: "POST", url: "Form/CheckQuestionPost" },
          data: _data,
          store: this.$store,
        }).then((res) => {
          //console.log('res', res);
          if (res != false) {
            q.isFilled=true;
            a.isFilled= true;
          }
      });
    },
    reFill(resultId){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Form/TestRefillByResultId" },
        params: { resultId: resultId },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        // console.log('res', res);
        if(res!=false){
          this.init();
        }
      });
    },
    init(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/TaskInheritedDetail" },
        params: { id: this.$route.params.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          if(res.data.task.i1>0){
            this.totalSec= res.data.task.i1*60;
          }
          this.initAfter();
        }
      });
    },
    initAfter() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Form/GetLatestResponse" },
        params: { form: this.$route.params.formId, courseId: this.$route.params.id, lessonId: null },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        // console.log('GetLatestResponse', res)
        if(res!=false){
          this.questions=res.data.questions;
          if(this.questions.length){
            this.resultId= res.data.resultId;
            const lastFilledQuestion = this.questions.reduce((acc, x) => (x.isFilled ? x : acc), null);
            const lastId = this.questions[this.questions.length - 1].id;
            this.activeQid= lastFilledQuestion ? lastFilledQuestion.id : this.questions[0]['id'];

            // if(this.questions.length)
            if(lastFilledQuestion){
              // console.log('lastFilledQuestion', lastFilledQuestion, this.questions.filter(x=>x.isFilled).length);
              const filledCnt= this.questions.filter(x=>x.isFilled).length;
              const minSec= this.totalSec*filledCnt/this.questions.length;
              // console.log('minSec', minSec);
              this.totalSec=this.totalSec - minSec;
            }

            if(lastFilledQuestion && lastId==lastFilledQuestion.id){
              this.totalSec= null;
              this.reFill(res.data.resultId);

              // MessageBox.confirm("Тоглох уу хуудасруу шилжих үү ?",
              //   "Бүх асуултад бөглөсөн байна.",
              //   {
              //     confirmButtonText: "Тийм",
              //     cancelButtonText: "Үгүй (Эхлүүлэх)",
              //     callback: action => {
              //       if (action == "cancel") {
              //         this.reFill(res.data.resultId);
              //         //console.log('step 1');
              //       } else if (action == "confirm") {
              //         this.$router.push({name: 'buddyQuiz'});
                      
              //       }
              //     }
              //   }
              // );
            }
          }
        }
      });
    },
    
  },
};
</script>
<style>
</style>